// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PSixVesselResult\ApiPSixVesselResult.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { PSixServiceVessel, PSixServiceVesselData, PSixServiceVesselOptions } from 'data/models/PSixServiceVessel';
import { PSixVesselDimension, PSixVesselDimensionData, PSixVesselDimensionOptions } from 'data/models/PSixVesselDimension';
import { PSixVesselParticular, PSixVesselParticularData, PSixVesselParticularOptions } from 'data/models/PSixVesselParticular';
import { PSixVesselServiceQuery, PSixVesselServiceQueryData, PSixVesselServiceQueryOptions } from 'data/models/PSixVesselServiceQuery';
import { PSixVesselTonnage, PSixVesselTonnageData, PSixVesselTonnageOptions } from 'data/models/PSixVesselTonnage';

// PSixVesselResultData is the class that PSixVesselResult serializes to/from
export interface PSixVesselResultData {
    Id : number;
	
    Dimensions : PSixVesselDimensionData[] | null;
    PSixVesselParticulars : PSixVesselParticularData | null;
    ServiceVessels : PSixServiceVesselData[] | null;
    Tonnages : PSixVesselTonnageData[] | null;
    VesselId : number | null;
    VesselServiceQuery : PSixVesselServiceQueryData | null;
    VesselServiceQueryId : number | null;
	
    ConstructionCompletedYear : number | null;
    CountryLookupName : string | null;
    CreatedOnUtc : /* ISO8601 */ string;
    Guid : /* GUID */ string;
    HullIdentificationNumber : string | null;
    Identification : string;
    ManufacturerHullNumber : string | null;
    OutOfServiceDate : /* ISO8601 */ string | null;
    ServiceType : string | null;
    StatusLookupName : string | null;
    VesselCallSign : string | null;
    VesselName : string | null;
}

// PSixVesselResultOptions is the class which may be passed to the PSixVesselResult constructor to define optional initial data values
export interface PSixVesselResultOptions {
    Id : number;
	
    Dimensions? : PSixVesselDimensionOptions[] | null;
    PSixVesselParticulars? : PSixVesselParticularOptions | null;
    ServiceVessels? : PSixServiceVesselOptions[] | null;
    Tonnages? : PSixVesselTonnageOptions[] | null;
    VesselId? : number | null;
    VesselServiceQuery? : PSixVesselServiceQueryOptions | null;
    VesselServiceQueryId? : number | null;
	
    ConstructionCompletedYear? : number | null;
    CountryLookupName? : string | null;
    CreatedOnUtc? : /* ISO8601 */ string;
    Guid? : /* GUID */ string;
    HullIdentificationNumber? : string | null;
    Identification? : string;
    ManufacturerHullNumber? : string | null;
    OutOfServiceDate? : /* ISO8601 */ string | null;
    ServiceType? : string | null;
    StatusLookupName? : string | null;
    VesselCallSign? : string | null;
    VesselName? : string | null;
}

export class PSixVesselResult {
    public Id : DataSignal<number>;
	
    public Dimensions : SDataArray<PSixVesselDimension>;
    public PSixVesselParticulars : DataSignal<PSixVesselParticular | null>;
    public ServiceVessels : SDataArray<PSixServiceVessel>;
    public Tonnages : SDataArray<PSixVesselTonnage>;
    public VesselId : DataSignal<number | null>;
    public VesselServiceQuery : DataSignal<PSixVesselServiceQuery | null>;
    public VesselServiceQueryId : DataSignal<number | null>;
	
    public ConstructionCompletedYear : DataSignal<number | null>;
    public CountryLookupName : DataSignal<string | null>;
    public CreatedOnUtc : DataSignal<TZDate>;
    public Guid : DataSignal<string>;
    public HullIdentificationNumber : DataSignal<string | null>;
    public Identification : DataSignal<string>;
    public ManufacturerHullNumber : DataSignal<string | null>;
    public OutOfServiceDate : DataSignal<TZDate | null>;
    public ServiceType : DataSignal<string | null>;
    public StatusLookupName : DataSignal<string | null>;
    public VesselCallSign : DataSignal<string | null>;
    public VesselName : DataSignal<string | null>;

    constructor();
    constructor(data : PSixVesselResultOptions);
    constructor(data: PSixVesselResultOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Dimensions = SArray<PSixVesselDimension>([]);
        this.PSixVesselParticulars = S.value<PSixVesselParticular | null>(null);
        this.ServiceVessels = SArray<PSixServiceVessel>([]);
        this.Tonnages = SArray<PSixVesselTonnage>([]);
        this.VesselId = jsonableObservable(S.value<number | null>(data && data.VesselId !== undefined ? data.VesselId : null));
        this.VesselServiceQuery = S.value<PSixVesselServiceQuery | null>(null);
        this.VesselServiceQueryId = jsonableObservable(S.value<number | null>(data && data.VesselServiceQueryId !== undefined ? data.VesselServiceQueryId : null));
	    
        this.ConstructionCompletedYear = jsonableObservable(S.value<number | null>(data && data.ConstructionCompletedYear !== undefined ? data.ConstructionCompletedYear : null));
        this.CountryLookupName = jsonableObservable(S.value<string | null>(data && data.CountryLookupName !== undefined ? data.CountryLookupName : null));
        this.CreatedOnUtc = jsonableObservable(S.value<TZDate>(data && data.CreatedOnUtc !== undefined ? new TZDate(data.CreatedOnUtc) : new TZDate(0), TZDate.eq));
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.HullIdentificationNumber = jsonableObservable(S.value<string | null>(data && data.HullIdentificationNumber !== undefined ? data.HullIdentificationNumber : null));
        this.Identification = jsonableObservable(S.value<string>(data && data.Identification !== undefined ? data.Identification : ''));
        this.ManufacturerHullNumber = jsonableObservable(S.value<string | null>(data && data.ManufacturerHullNumber !== undefined ? data.ManufacturerHullNumber : null));
        this.OutOfServiceDate = jsonableObservable(S.value<TZDate | null>(data && data.OutOfServiceDate !== undefined ? data.OutOfServiceDate === null ? null : new TZDate(data.OutOfServiceDate) : null, TZDate.nullableEq));
        this.ServiceType = jsonableObservable(S.value<string | null>(data && data.ServiceType !== undefined ? data.ServiceType : null));
        this.StatusLookupName = jsonableObservable(S.value<string | null>(data && data.StatusLookupName !== undefined ? data.StatusLookupName : null));
        this.VesselCallSign = jsonableObservable(S.value<string | null>(data && data.VesselCallSign !== undefined ? data.VesselCallSign : null));
        this.VesselName = jsonableObservable(S.value<string | null>(data && data.VesselName !== undefined ? data.VesselName : null));
    }

    static key(obj : PSixVesselResult) {
        return obj.Id();
    }
    
    static dataKey(obj : PSixVesselResultOptions) {
        return obj.Id;
    }

    static update(obj : PSixVesselResult, data : PSixVesselResultOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.VesselId !== undefined) obj.VesselId(data.VesselId);
            if (data.VesselServiceQueryId !== undefined) obj.VesselServiceQueryId(data.VesselServiceQueryId);
	        
            if (data.ConstructionCompletedYear !== undefined) obj.ConstructionCompletedYear(data.ConstructionCompletedYear);
            if (data.CountryLookupName !== undefined) obj.CountryLookupName(data.CountryLookupName);
            if (data.CreatedOnUtc !== undefined) obj.CreatedOnUtc(new TZDate(data.CreatedOnUtc));
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.HullIdentificationNumber !== undefined) obj.HullIdentificationNumber(data.HullIdentificationNumber);
            if (data.Identification !== undefined) obj.Identification(data.Identification);
            if (data.ManufacturerHullNumber !== undefined) obj.ManufacturerHullNumber(data.ManufacturerHullNumber);
            if (data.OutOfServiceDate !== undefined) obj.OutOfServiceDate(data.OutOfServiceDate === null ? null : new TZDate(data.OutOfServiceDate));
            if (data.ServiceType !== undefined) obj.ServiceType(data.ServiceType);
            if (data.StatusLookupName !== undefined) obj.StatusLookupName(data.StatusLookupName);
            if (data.VesselCallSign !== undefined) obj.VesselCallSign(data.VesselCallSign);
            if (data.VesselName !== undefined) obj.VesselName(data.VesselName);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PSixVesselResult.ts